import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import FormField from "Components/Forms/FormComponent/FormFiled";
import InputFiled from "Components/Forms/InputForm/InputField";
import TextAreaInput from "Components/Forms/TextAreaForm/TextArea";
import FileUpload from "Pages/WorkInformation/FileUpload/FileUpload";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckDouble,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import axiosInstance from "../../axios";
import CustomReactSelect from "Components/Forms/ReactSelect/ReactSelect";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  doc,
  getDoc,
  collection,
  addDoc,
  updateDoc,
  arrayRemove,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { uploadImage } from "../../utils/imageUpload";
import { FieldArray, Formik, Form } from "formik";
import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import SliderUploader from "Pages/WorkInformation/FileUpload/SliderUploader";
import ImageUploader from "./ImageUploader";

const AddNewCase = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("edit");
  const [documentData, setDocumentData] = useState(null);
  const [itemsOrderr, setItemsOrder] = useState([]);
  const [firstImage, setFirstImage] = useState();
  const [secondImage, setSecondImage] = useState();
  const [beforeImage, setBeforeImage] = useState();

  // Existing image URLs
  const [existingCover, setExistingCover] = useState(null);
  const [existingAfter, setExistingAfter] = useState(null);
  const [existingBefore, setExistingBefore] = useState(null);

  const [selectedSpecialty, setSelectedSpecialty] = useState("");
  const [selectedSpecialtyError, setSelectedSpecialtyError] = useState(false);
  const [specialtyOptions, setSpecialtyOptions] = useState([]);
  const [loadingSpecialties, setLoadingSpecialties] = useState(true);

  // Fetch specialty options from Firebase
  useEffect(() => {
    const fetchSpecialties = async () => {
      setLoadingSpecialties(true);
      try {
        const specialtiesRef = collection(db, "Specialties");
        const snapshot = await getDocs(specialtiesRef);
        const options = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setSpecialtyOptions(options);
        
        // Set default value if available
        if (options.length > 0 && !selectedSpecialty) {
          setSelectedSpecialty(options[0].value);
        }
      } catch (error) {
        console.error("Error fetching specialties:", error);
        toast.error("Failed to load specialties");
      } finally {
        setLoadingSpecialties(false);
      }
    };

    fetchSpecialties();
  }, []);

  const validationSchema = Yup.object().shape({
    SubTitle: Yup.string().required(t("required")),
    Title: Yup.string().required(t("required")),
    Details: Yup.string().required(t("required")),
  });

  const [initialValues, setInitialValues] = useState({
    SubTitle: "",
    Title: "",
    Details: "",
  });

  const [fetchLoading, setFetchLoading] = useState(false);

  function generateUniqueKey() {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 15);
    return `${timestamp}-${randomString}`;
  }

  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);

    setSelectedFiles(updatedFiles);

    try {
      const docRef = doc(db, "OurClinc", "images");
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });

      toast.success(t("FileDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(t("FileDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  const [city, setCity] = useState();
  const [loading, setLoading] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesError, setSelectedFilesError] = useState(false);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [selectedFilesError2, setSelectedFilesError2] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [selectedCategoryError, setSelectedCategoryError] = useState();
  const [selectedCityError, setSelectedCityError] = useState();
  const [items, setItems] = useState(["contractor", "advisor", "provider"]);
  const type = useSelector((state) => state.auth.type);

  useEffect(() => {
    const fetchExistingImages = async () => {
      try {
        const docRef = doc(db, "OurService", "services");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          console.log("Existing images:", docSnap.data());
          const imagesCollectionRef = collection(docRef, "Cards");
          const imagesCollectionSnap = await getDocs(imagesCollectionRef);

          imagesCollectionSnap.forEach((doc) => {
            console.log(doc.data);
            console.log(doc.id);
          });
        }
      } catch (error) {
        console.error("Error fetching existing images:", error);
      }
    };

    fetchExistingImages();
  }, []);

  const [showModal, setShowModalSuccess] = useState(false);
  const router = useNavigate();

  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };

  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const validateForm = () => {
    let isValid = true;
    
    if (!selectedSpecialty) {
      setSelectedSpecialtyError(true);
      isValid = false;
    } else {
      setSelectedSpecialtyError(false);
    }
    
    if (!firstImage && !existingCover) {
      toast.error("Cover image is required");
      isValid = false;
    }
    
    if (!secondImage && !existingAfter) {
      toast.error("After image is required");
      isValid = false;
    }
    
    if (!beforeImage && !existingBefore) {
      toast.error("Before image is required");
      isValid = false;
    }
    
    return isValid;
  };

  const handleSubmit = async (values) => {
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);

    let firstImageUrl = existingCover;
    let secondImageUrl = existingAfter;
    let thirdImageUrl = existingBefore;

    try {
      const uploadPromises = [];
      if (firstImage && firstImage.file) {
        uploadPromises.push(
          (async () => {
            try {
              firstImageUrl = await uploadImage(firstImage.file);
            } catch (error) {
              console.error("First image upload error:", error);
              throw error;
            }
          })()
        );
      }
      if (secondImage && secondImage.file) {
        uploadPromises.push(
          (async () => {
            try {
              secondImageUrl = await uploadImage(secondImage.file);
            } catch (error) {
              console.error("Second image upload error:", error);
              throw error;
            }
          })()
        );
      }
      if (beforeImage && beforeImage.file) {
        uploadPromises.push(
          (async () => {
            try {
              thirdImageUrl = await uploadImage(beforeImage.file);
            } catch (error) {
              console.error("Before image upload error:", error);
              throw error;
            }
          })()
        );
      }

      await Promise.all(uploadPromises);

      const collectionRef = collection(db, "Cases", "Cases", "Cards");

      const filteredValues = Object.fromEntries(
        Object.entries({
          ...values,
          Specialty: selectedSpecialty,
          CoverImage: firstImageUrl,
          AfterImage: secondImageUrl,
          BeforeImage: thirdImageUrl,
          createdAt: serverTimestamp(),
        }).filter(([_, value]) => value !== undefined)
      );

      if (editId) {
        const docRef = doc(db, "Cases", "Cases", "Cards", editId);
        await updateDoc(docRef, filteredValues);
        toast.success("Case updated successfully");
        router("/AllCases");
      } else {
        await addDoc(collectionRef, filteredValues);
        toast.success("Case added successfully");
        setInitialValues({
          SubTitle: "",
          Title: "",
          Details: "",
        });
        setFirstImage(null);
        setSecondImage(null);
        setBeforeImage(null);
      }
    } catch (error) {
      console.error("Error saving document:", error);
      toast.error("Failed to save case.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (editId) {
      const fetchCase = async () => {
        try {
          setFetchLoading(true);
          const docRef = doc(db, "Cases", "Cases", "Cards", editId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            setInitialValues({
              SubTitle: data.SubTitle || "",
              Title: data.Title || "",
              Details: data.Details || "",
            });
            setSelectedSpecialty(data.Specialty || "");
            setExistingCover(data.CoverImage || null);
            setExistingAfter(data.AfterImage || null);
            setExistingBefore(data.BeforeImage || null);
          }
        } catch (error) {
          console.error("Error fetching case details:", error);
        } finally {
          setFetchLoading(false);
        }
      };
      fetchCase();
    }
  }, [editId]);

  return (
    <>
      <HelmetInfo titlePage={t("addNewProject")} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <div className="d-flex justify-content-end"></div>
        <WorkHeaderInfo title={editId ? "Edit Case" : "Add New Case"} />
        

        
        <div className="form-project-management">
          {!fetchLoading && (
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ values, handleChange, handleBlur }) => (
                <Form>
                  <div className="row">
                    <div className="col-12 col-md-12">
                      <h6>SubTitle</h6>
                      <textarea
                        name="SubTitle"
                        onChange={handleChange}
                        value={values.SubTitle}
                        rows={4}
                        style={{ width: "100%", resize: "vertical" }}
                      />
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          padding: "10px",
                        }}
                      >
                        <h6>Subtitle Will Appear Like That</h6>
                        {values.SubTitle || "Your text will appear here..."}
                      </div>
                    </div>

                    <div className="col-12 col-md-12">
                      <h6>Title</h6>
                      <textarea
                        name="Title"
                        onChange={handleChange}
                        value={values.Title}
                        rows={4}
                        style={{ width: "100%", resize: "vertical" }}
                      />
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          padding: "10px",
                        }}
                      >
                        <h6>Title Will Appear Like That</h6>
                        {values.Title || "Your text will appear here..."}
                      </div>
                    </div>

                    <h4>{t("Details")}</h4>
                    <div className="col-12 col-md-12">
                      <textarea
                        name="Details"
                        onChange={handleChange}
                        value={values.Details}
                        rows={4}
                        style={{ width: "100%", resize: "vertical" }}
                      />
                      <div
                        style={{
                          whiteSpace: "pre-wrap",
                          marginTop: "10px",
                          border: "1px solid #ccc",
                          padding: "10px",
                        }}
                      >
                        <h6>Details Will Appear Like That</h6>
                        {values.Details || "Your text will appear here..."}
                      </div>
                    </div>
                    <div className="col-lg-12 mb-4">
                      {loadingSpecialties ? (
                        <div className="text-center">
                          <span className="loader"></span>
                        </div>
                      ) : (
                        <CustomReactSelect
                          label={t("Specialty")}
                          name="Specialty"
                          options={specialtyOptions}
                          defaultValue={specialtyOptions.filter(
                            option => option.value === selectedSpecialty
                          )}
                          changeValue={(option) =>
                            setSelectedSpecialty(option.value)
                          }
                        />
                      )}
                      {selectedSpecialtyError && (
                        <div className="text-danger">{t("required")}</div>
                      )}
                    </div>
                    <ImageUploader
                      setFile={setFirstImage}
                      title={"Upload Cover image"}
                    />
                    {existingCover && !firstImage && (
                      <div className="text-center mb-3">
                        <img src={existingCover} alt="Current Cover" style={{ width: "100px", height: "auto" }} />
                      </div>
                    )}
                    <ImageUploader
                      setFile={setSecondImage}
                      title={"Upload After image"}
                    />
                    {existingAfter && !secondImage && (
                      <div className="text-center mb-3">
                        <img src={existingAfter} alt="Current After" style={{ width: "100px", height: "auto" }} />
                      </div>
                    )}
                    <ImageUploader
                      setFile={setBeforeImage}
                      title={"Upload Before image"}
                    />
                    {existingBefore && !beforeImage && (
                      <div className="text-center mb-3">
                        <img src={existingBefore} alt="Current Before" style={{ width: "100px", height: "auto" }} />
                      </div>
                    )}
                    <button className="btn-main w-100" type="submit">
                      {loading ? (
                        <span className="loader"></span>
                      ) : (
                        editId ? "Edit Case" : "Add New Case"
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          )}
        </div>
      </div>
    </>
  );
};

export default AddNewCase;